export interface SetQueryEventProps {
  query: string
}

up.compiler(
  '[data-fill-slot-with-query]',
  { priority: -1 },
  (element, { target, query }: { target: string; query: string }) => {
    let event

    if (target === 'header-search') {
      event = 'app.headerSearch.setQuery'
    } else if (target === 'native-app-search') {
      event = 'app.nativeAppSearch.setQuery'
    }

    up.emit<SetQueryEventProps>(event!, { query })
  },
)
